import { render, staticRenderFns } from "./FrzPackingGroupDetail.vue?vue&type=template&id=f33a3fb4"
import script from "./FrzPackingGroupDetail.vue?vue&type=script&lang=js"
export * from "./FrzPackingGroupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports